const locale = {
  placeholder: 'Оберіть час',
  rangePlaceholder: ['Початковий час', 'Кінцевий час']
};
export default locale;